import React from 'react';
export function CardLogos() {
  return <div className="flex flex-wrap items-center gap-3 mt-3" data-id="element-451">
      {/* Visa */}
      <div className="bg-white px-2 py-1 rounded border border-gray-200 shadow-sm h-8 flex items-center justify-center min-w-[48px]" data-id="element-452">
        <img src="https://cdn.magicpatterns.com/uploads/8dFj1ebd13MwAe3XqFYNrR/Visa_Logo.png" alt="Visa" className="h-4 object-contain" data-id="element-453" />
      </div>

      {/* Mastercard */}
      <div className="bg-white px-2 py-1 rounded border border-gray-200 shadow-sm h-8 flex items-center justify-center min-w-[48px]" data-id="element-454">
        <img src="https://cdn.magicpatterns.com/uploads/qD9CTacyXTdwXXPtrCxZQw/MasterCard_Logo.png" alt="Mastercard" className="h-5 object-contain" data-id="element-455" />
      </div>

      {/* UnionPay */}
      <div className="bg-white px-2 py-1 rounded border border-gray-200 shadow-sm h-8 flex items-center justify-center min-w-[48px]" data-id="element-456">
        <img src="https://cdn.magicpatterns.com/uploads/8TcgwChg7bMUnkD6TfzVkn/UnionPay_Logo.png" alt="UnionPay" className="h-5 object-contain" data-id="element-457" />
      </div>

      {/* PayPak */}
      <div className="bg-white px-2 py-1 rounded border border-gray-200 shadow-sm h-8 flex items-center justify-center min-w-[48px]" data-id="element-458">
        <img src="https://cdn.magicpatterns.com/uploads/u4UiZ3PWX5VH4BCbbcVNsE/PayPak_Logo.png" alt="PayPak" className="h-5 object-contain" data-id="element-459" />
      </div>
    </div>;
}